import { InterestTypes } from '@kcftech/prometheus-client';
import { MultiSelect } from 'components/forms/multiselect/MultiSelect';
import { PersonaModalPageProps } from 'components/modal/persona/PersonaModal';
import { useMemo } from 'react';

export type PersonaModalPage2Props = Readonly<
    Omit<PersonaModalPageProps, 'selections'> & { selection: InterestTypes[] | undefined }
>;

export function PersonaModalPage2({
    form: { setValue },
    options,
    selection,
}: PersonaModalPage2Props) {
    const interestOptions = useMemo(
        () =>
            options?.PersonaInterests.map((p) => ({
                value: InterestTypes[p.Value as keyof typeof InterestTypes],
                title: p.Text,
            })),
        [options?.PersonaInterests],
    );

    if (!interestOptions) {
        return null;
    }

    return (
        <MultiSelect
            options={interestOptions}
            selectedOptions={selection ?? []}
            labelPrefersMinWidth
            onChange={(s) => {
                setValue(
                    'personaInterests',
                    s.selected.map(
                        (i) => InterestTypes[i.value as keyof typeof InterestTypes],
                    ),
                );
            }}
        />
    );
}
